import React from 'react'
import { motion } from 'framer-motion'
import { smoothAnimations, optimizedViewport } from '../utils/animations'

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 dark:from-black dark:via-gray-900 dark:to-slate-900 text-white overflow-hidden min-h-screen" style={{ minHeight: '100vh', minHeight: '100dvh' }}>
      {/* Professional background pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(30,30,40,0.8),rgba(15,15,25,0.9))] opacity-60"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(99,102,241,0.1),transparent)] opacity-40"></div>
      
      <div className="relative pt-32 md:pt-24 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          {/* Professional company branding */}
          <motion.div
            className="mb-8"
            {...smoothAnimations.fadeInUp}
            style={{ willChange: 'transform, opacity' }}
          >
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight mb-6">
              <span className="text-white">Orifel Technologies</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-6"></div>
          </motion.div>
          
          {/* Professional tagline */}
          <motion.p 
            className="text-xl md:text-2xl font-medium text-gray-200 mb-8 tracking-wide"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 0.46, 0.45, 0.94] }}
            style={{ willChange: 'transform, opacity' }}
          >
            Enterprise Technology Solutions & Digital Innovation
          </motion.p>
          
          {/* Professional description */}
          <motion.p 
            className="text-lg md:text-xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            style={{ willChange: 'transform, opacity' }}
          >
            Delivering secure, scalable, and innovative technology solutions for businesses worldwide. From payment infrastructure to custom software development, we provide the expertise and reliability your enterprise needs.
          </motion.p>
          
          {/* Professional call-to-action buttons */}
          <motion.div 
            className="flex flex-col sm:flex-row gap-6 justify-center items-center"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
            style={{ willChange: 'transform, opacity' }}
          >
            <motion.a 
              href="#products" 
              className="group px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/25 min-w-[200px] text-center"
              {...smoothAnimations.hoverScale}
              data-analytics="cta"
            >
              <span className="relative z-10">View Solutions</span>
            </motion.a>
            
            <motion.a 
              href="#contact" 
              className="group px-8 py-4 border-2 border-white/30 hover:border-white text-white hover:bg-white hover:text-slate-900 rounded-lg font-semibold transition-all duration-300 min-w-[200px] text-center"
              {...smoothAnimations.hoverScale}
              data-analytics="cta"
            >
              <span className="relative z-10">Contact Us</span>
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Hero
